import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const MiyagiCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "36px",
      })}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("ポイント付与について")}</Heading>
        <p
          className={css({
            fontSize: "16px",
            lineHeight: "1.5",
            letterSpacing: "0.16px",
            color: "text.primary",
          })}
        >
          {t(
            "「みやぎ防災」ミニアプリの利用登録を行った方に、3,000ポイントをプレゼントします。（※注1）",
          )}
          <br />
          {t(
            "応募すると、ただちにポイントが付与され、令和10年3月31日までの期間、対象店舗で1ポイント=1円として利用できます。",
          )}
        </p>
      </div>

      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t(
          "※注1: 令和8年6月30日以前のキャンペーンで3,000ポイントを受領したことのある方は対象外です。",
        )}
      </p>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("応募の方法")}</Heading>
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        })}
      >
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          })}
        >
          <h3
            className={css({
              fontSize: "16px",
              fontWeight: "700",
              lineHeight: "1.5",
              letterSpacing: "0.16px",
              color: "text.primary",
            })}
          >
            {t("STEP1：応募ボタンをタップ")}
          </h3>
          <p
            className={css({
              fontSize: "16px",
              lineHeight: "1.5",
              letterSpacing: "0.16px",
              color: "text.primary",
            })}
          >
            {t(
              "「みやぎポイント」アプリのホーム画面から、「応募する」ボタンを押します。",
            )}
          </p>
        </div>

        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          })}
        >
          <h3
            className={css({
              fontSize: "16px",
              fontWeight: "700",
              lineHeight: "1.5",
              letterSpacing: "0.16px",
              color: "text.primary",
            })}
          >
            {t("STEP2：みやぎ防災アプリに登録")}
          </h3>
          <p
            className={css({
              fontSize: "16px",
              lineHeight: "1.5",
              letterSpacing: "0.16px",
              color: "text.primary",
            })}
          >
            {t(
              "画面が「みやぎ防災」アプリに切り替わりますので、利用登録を行ってください。登録後、ポイントが付与されます（「みやぎポイント」のホーム画面で3,000ポイントが付与されたことをご確認ください）。",
            )}
            <br />
            {t(
              "※すでに「みやぎ防災」を登録済の場合は、STEP1の後、ただちにポイントが付与されます。",
            )}
          </p>
        </div>
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("スケジュール")}</Heading>
        <ul
          className={css({
            listStyleType: "disc",
            paddingLeft: "24px",
            fontSize: "16px",
            lineHeight: "1.5",
            letterSpacing: "0.16px",
            color: "text.primary",
          })}
        >
          <li>{t("令和8年8月1日　ポイント付与開始")}</li>
          <li>{t("令和9年3月31日をもって、ポイント付与を終了します。")}</li>
          <li>{t("ポイントの利用は令和10年3月31日まで")}</li>
        </ul>
      </div>
    </div>
  );
};
